export default "/lineup-tool/assets/redux/arrow-down.svg";